import { createSelectors } from '@leverege/ui-redux';
import Constants from '../Constants.js';
const initialState = {
  // projectId :
  //   status : 'loading',
  //   error : { },
  //   oidcClients : {
  //   client0Id : { ...client0 },
  // ... 
  // } 
  //  oidcClientStatus : {
  //    id : { status, error }
  //  }
  //
};
const EMPTY = Object.freeze({});

/**
 * @function transformState 
 * @param {object} currentState 
 * @param {string} id 
 * @param {string} status 
 * @param {string} error 
 * @returns {object|null}
 */
function transformState(currentState, id, status = null, error = null) {
  if (id == null) {
    if (currentState == null) {
      return {
        oidcClients: {},
        oidcClientStatus: {},
        status,
        error
      };
    }
    return {
      oidcClients: {},
      oidcClientStatus: {},
      ...currentState,
      status,
      error
    };
  }
  let rtn = null;
  if (currentState == null) {
    rtn = {
      status: null,
      error: null,
      oidcClients: {},
      oidcClientStatus: {}
    };
  } else {
    rtn = {
      ...currentState,
      oidcClientStatus: {
        ...currentState.oidcClientStatus
      }
    };
    if (status == null) {
      delete rtn.oidcClientStatus[id];
    } else {
      rtn.oidcClientStatus[id] = {
        status,
        error
      };
    }
  }
  return rtn;
}

/**
 * @function oidcClients Reduce OIDC Client state 
 * @param {object} state 
 * @param {object} action 
 * @returns {object} A new state object 
 */
// eslint-disable-next-line default-param-last
function oidcClients(state = initialState, action) {
  switch (action.type) {
    case Constants.OIDC_CLIENT_STATUS:
      {
        const {
          projectId,
          oidcClientId,
          status,
          error = null
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = transformState(state[projectId], oidcClientId, status, error);
        return nState;
      }
    case Constants.OIDC_CLIENT_GET:
      {
        const {
          projectId,
          oidcClient
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = transformState(state[projectId], oidcClient.id);
        nState[projectId].oidcClients = {
          ...nState[projectId].oidcClients,
          [oidcClient.id]: oidcClient
        };
        return nState;
      }
    case Constants.OIDC_CLIENT_LIST:
      {
        const {
          projectId,
          oidcClients
        } = action;
        const nState = {
          ...state
        };
        const clients = oidcClients || [];
        nState[projectId] = transformState(state[projectId]);
        const oidcClientsMap = {};
        clients.forEach(client => {
          if (client?.id) {
            oidcClientsMap[client.id] = client;
          }
        });
        nState[projectId].oidcClients = oidcClientsMap;
        return nState;
      }
    case Constants.OIDC_CLIENT_ADD:
      {
        const {
          projectId,
          oidcClient
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = transformState(state[projectId]);
        nState[projectId].oidcClients = {
          ...nState[projectId].oidcClients,
          [oidcClient.id]: oidcClient
        };
        return nState;
      }
    case Constants.OIDC_CLIENT_REMOVE:
      {
        const {
          projectId,
          oidcClientId
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = transformState(state[projectId], oidcClientId);
        delete nState[projectId].oidcClients[oidcClientId];
        return nState;
      }
    case Constants.OIDC_CLIENT_UPDATE:
      {
        const {
          projectId,
          oidcClient
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = transformState(state[projectId], oidcClient.id);
        nState[projectId].oidcClients[oidcClient.id] = oidcClient;
        return nState;
      }
    case Constants.OIDC_CLIENT_LOGIN_URL:
      {
        const {
          projectId,
          oidcClientId,
          oidcClientLoginUrl
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = transformState(state[projectId], oidcClientId);
        // The UI may need the login URL without having read acess to fetch the OIDC client itself
        if (!nState[projectId].oidcClients[oidcClientId]) {
          nState[projectId].oidcClients[oidcClientId] = {
            id: oidcClientId
          };
        }
        nState[projectId].oidcClients[oidcClientId].loginUrl = oidcClientLoginUrl;
        return nState;
      }
    default:
      {
        return state;
      }
  }
}

/**
 * @function getStatus
 * @param {object} state 
 * @param {string} projectId 
 * @param {string} id 
 * @returns {object}
 */
function getStatus(state, projectId, id) {
  const projId = projectId || process?.env?.projectId;
  if (state?.[projId]) {
    if (id != null) {
      const clientStatus = state[projId]?.oidcClientStatus;
      return clientStatus?.[id]?.status ? clientStatus[id].status : null;
    }
    return state[projId].status;
  }
  return null;
}

/**
 * @function getError
 * @param {object} state 
 * @param {string} projectId 
 * @param {string} id 
 * @returns {object}
 */
function getError(state, projectId, id) {
  const projId = projectId || process?.env?.projectId;
  if (state?.[projId]) {
    if (id != null) {
      const clientStatus = state[projId].oidcClientStatus;
      return clientStatus?.[id]?.error ? clientStatus[id].error : null;
    }
    return state[projId].error;
  }
  return null;
}

/**
 * @function getOidcClients
 * @param {object} state 
 * @param {string} projectId 
 * @returns {object}
 */
function getOidcClients(state, projectId) {
  const projId = projectId || process?.env?.projectId;
  return state?.[projId]?.oidcClients || EMPTY;
}
oidcClients.getStatus = getStatus;
oidcClients.getError = getError;
oidcClients.getOidcClients = getOidcClients;
oidcClients.createSelectors = (key, createSetStateKey = false) => {
  return createSelectors(key, {
    getOidcClients,
    getStatus,
    getError
  }, createSetStateKey);
};

// Set up initial defaults to make methods available immediately with default state key
const selectors = oidcClients.createSelectors('oidc', true);
Object.keys(selectors).forEach(key => {
  oidcClients[key] = selectors[key];
});
export default oidcClients;